import { render } from "./PlanElementForm.vue?vue&type=template&id=241606ee&scoped=true"
import script from "./PlanElementForm.vue?vue&type=script&lang=js"
export * from "./PlanElementForm.vue?vue&type=script&lang=js"

import "./PlanElementForm.vue?vue&type=style&index=0&id=241606ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241606ee"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QColor from 'quasar/src/components/color/QColor.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QTabPanels,QTabPanel,QInput,QTooltip,QBtn,QMenu,QColor,QCheckbox,QToggle,QSelect});
